<template>
	<a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="id" name="id">
					<a-input v-model:value="form.id" />
				</a-form-item>
			</div>
			<a-form-item label="项目名称" name="projectId">
				<a-select :disabled="form.id" v-model:value="form.projectId" :options="projectData" placeholder="请选择" />
			</a-form-item>
		</a-form>
	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { projectEvaluationInfo, corpProjectInfo } from "@/api/achievementsService";
import { education, dateFormat } from "@/config/variableConfig";

export default {
	name: "UserModal",
	components: {},

	mixins: [formMixin],
	data() {
		return {
			education,
			dateFormat,
			projectData: [],
			form: {
				id: null,
				projectId: null,
			},
			rules: {
				projectId: [dataCheck.required({})],
				id: []
			},
			submitUrl: projectEvaluationInfo.saveOrUpdate
		}
	},
	methods: {
		getProjectOptions() {
			this.getAction({
				url: corpProjectInfo.noPageList,
			}).then(res => {
				let arr = []
				res.map(item => {
					arr.push({
						label: item.projectName,
						value: item.id
					})
				})
				this.projectData = arr
			})
		},
	},
	mounted() {
		this.getProjectOptions()
	}
}
</script>
<style scoped lang="less"></style>
